import React from "react";
import styled from "styled-components";

const Spinner = styled.span.attrs({
  className:
    "w-5 h-5 ml-3 mr-2 ease-linear border-4 border-t-4 rounded-full animate-spin spinner",
})`
  display: ${(props) => (props.saving ? "block" : "none")};
`;

export default Spinner;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/SharePhotoModal/CaptionInput/Spinner.jsx